import { render, staticRenderFns } from "./base_button.vue?vue&type=template&id=62c2e81c&scoped=true&"
import script from "./base_button.vue?vue&type=script&setup=true&lang=ts&"
export * from "./base_button.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./base_button.vue?vue&type=style&index=0&id=62c2e81c&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c2e81c",
  null
  
)

export default component.exports